import React, { Component } from "react";
import { Link } from "react-router-dom";

import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import styled from "styled-components";
import { Button, Flex, Image, Text } from "rebass";
import { Block, Input } from "reakit";
import logo from "../../resources/img/logo-new.png";
import "../../index.css";

const PageContainer = styled(Flex)`
  width: 100vw;
  height: 100vh;
  @media screen and (max-width: 768px) {
    justify-content: unset;
    padding-top: 5.5rem;
  }
  .auth-input {
    background-color: #121212;
    border-bottom: 3px solid #5f646b;
    color: #ffffff;
    border-radius: 0;
    font-size: 1.68rem;
    padding: 0;
    // min-width: 29rem;
    width: 26vw;
    height: 3.1rem;
    font-weight: 600;
  }

  .auth-input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #5f646b;
    opacity: 1;
    /* Firefox */
  }

  .auth-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #5f646b;
  }

  .auth-input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #5f646b;
  }

  /* input.auth-input:not(:placeholder-shown), */
  input.auth-input:focus {
    border-bottom: 3px solid #ffffff;
  }

  input.auth-input.error {
    border-bottom: 3px solid #f95050;
  }

  .auth-btn {
    width: 100%;
    background-color: #317fb5;
    font-size: 1.68rem;
    height: 4rem;
  }

  .error-text {
    max-width: 26rem;
    text-align: center;
  }
  @media screen and (max-width: 1800px) {
    .auth-input {
      font-size: 1.5rem;
    }
    .auth-btn {
      font-size: 1.5rem;
      height: 3.5rem;
    }
  }
  @media screen and (max-width: 1420px) {
    .auth-input {
      font-size: 1.2rem;
      width: 30vw;
    }
    .auth-btn {
      font-size: 1.2rem;
      height: 3.1rem;
    }
  }
  @media screen and (max-width: 1024px) {
    .auth-input {
      font-size: 1.1rem;
      width: 32vw;
    }

    .auth-btn {
      font-size: 1.1rem;
    }
    .error-text {
      max-width: 18rem;
    }
  }
  @media screen and (max-width: 950px) {
    .auth-input {
      width: 35vw;
    }
  }
  @media screen and (max-width: 768px) {
    .auth-input {
      font-size: 1rem;
      min-width: 18rem;
    }

    .auth-btn {
      background-color: #317fb5;
      font-size: 1rem;
    }

    .error-text {
      max-width: 18rem;
    }
  }
  .auth-logo {
    height: 17.3vw;
    margin-top: -2rem;
  }

  @media screen and (max-width: 1800px) {
    .auth-logo {
      height: 18vw;
    }
  }
  @media screen and (max-width: 1420px) {
    .auth-logo {
      height: 19vw;
    }
  }
  @media screen and (max-width: 1376px) {
    .auth-logo {
      height: 20vw;
    }
  }
  @media screen and (max-width: 1024px) {
    .auth-logo {
      height: 23vw;
    }
  }
  @media screen and (max-width: 950px) {
    .auth-logo {
      height: 25vw;
    }
  }
  @media screen and (max-width: 768px) {
    .auth-logo {
      height: 14.5rem;
    }
  }
`;

const PasswordForgetPage = () => (
  <PageContainer
    m={0}
    p={0}
    bg="#121212"
    justifyContent={"center"}
    alignItems={"center"}
    flexDirection={"column"}
  >
    <Flex justifyContent={"center"} width={1}>
      <Block>
        <Image src={logo} className="auth-logo" />
      </Block>
    </Flex>
    <Block>
      <PasswordForgetForm />
    </Block>

    <LoginPageLink />
  </PageContainer>
);

const INITIAL_STATE = {
  email: "",
  error: null,
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE, success: false };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE, success: true });
      })
      .catch((error) => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error, success } = this.state;

    const isInvalid = email === "";

    if (success) {
      return <Text color={"white"}>A password reset email has been sent.</Text>;
    }
    return (
      <form onSubmit={this.onSubmit}>
        <Flex justifyContent={"center"} width={1}>
          <Text className="error-text" color="#F95050">
            {error && <p>{error.message}</p>}
          </Text>
        </Flex>
        <Input
          name="email"
          value={this.state.email}
          className={error ? "auth-input error" : "auth-input"}
          onChange={this.onChange}
          type="text"
          placeholder="Email"
        />
        <Flex justifyContent={"center"} pt={3}>
          <Button
            className="auth-btn"
            mt={4}
            variant={"pwReset"}
            disabled={isInvalid}
            type="submit"
          >
            Reset Password
          </Button>
        </Flex>
      </form>
    );
  }
}

const StyledForgetText = styled(Text)`
  a {
    text-decoration: none;
    color: white;
    font-weight: 600;
    font-size: 1.4rem;
  }
  margin-top: 4.1rem;

  @media screen and (max-width: 1800px) {
    a {
      font-size: 1.3rem;
    }
  }

  @media screen and (max-width: 1420px) {
    a {
      font-size: 1rem;
    }
  }
`;

const PasswordForgetLink = () => (
  <StyledForgetText color={"white"} p={2}>
    <Link to={ROUTES.PASSWORD_FORGET}>Forgot Password?</Link>
  </StyledForgetText>
);

const LoginPageLink = () => (
  <StyledForgetText color={"white"} p={2}>
    <Link to={ROUTES.LANDING}>Back to login</Link>
  </StyledForgetText>
);

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm, PasswordForgetLink };
